module.exports = __webpack_public_path__ + "img/medium.176c2236.svg";